import { DEFAULT_CURRENCY } from '@/constants';
import {
  useGetCurrencyRatesListQuery,
  useGetOrganizationsListQuery,
  useGetProductSkusQuery,
} from '@/queries';

export const useGetProductBiId = ({ locale, params }) => {
  const { data: product, status: productLoaderStatus } = useGetProductSkusQuery(
    {
      locale,
      params,
    }
  );
  const { data: companies, status: companiesLoaderStatus } =
    useGetOrganizationsListQuery({ locale });
  const { data: currencyRate } = useGetCurrencyRatesListQuery(
    { currency: params?.currency },
    { skip: !params?.currency || params?.currency === DEFAULT_CURRENCY }
  );
  const companyData = companies?.[product?.vendorId];
  const isFetching =
    companiesLoaderStatus === 'pending' || productLoaderStatus === 'pending';
  const isError =
    companiesLoaderStatus === 'rejected' || productLoaderStatus === 'rejected';
  const productData = {
    ...companyData,
    ...product,
    loanLimitNumberMaxUah:
      params?.currency !== DEFAULT_CURRENCY
        ? product?.loanLimitNumberMax * (currencyRate?.rate || 0)
        : 0,
    loanLimitNumberMinUah:
      params?.currency !== DEFAULT_CURRENCY
        ? product?.loanLimitNumberMin * (currencyRate?.rate || 0)
        : 0,
    currencyRate:
      params?.currency !== DEFAULT_CURRENCY ? currencyRate || {} : 0,
  };

  // if ((!companyData || !product) && (isFetching || isError)) {
  //   return {
  //     productData: null,
  //     isFetching,
  //     isError,
  //   };
  // }

  return {
    productData: Object.keys(productData || {})?.length ? productData : null,
    isFetching,
    isError,
  };
};

export default useGetProductBiId;
